import React from 'react'

import { colors as zetColors } from '@zet/design-system'
import { Icon } from '@zet/design-system/icons'
import { Stack } from '@zet/design-system/layout'
import { Text } from '@zet/design-system/typography'

import LimeLight from '../../svg/LimeLight'

interface BottomLayoutProps {
  focused: boolean
  icon: string
  label: string
}

const BottomTabLayout = ({ focused, icon, label }: BottomLayoutProps) => {
  return (
    <Stack className={`flex items-center`}>
      {focused && (
        <Stack
          className="relative -top-[3] h-[2] w-[32] rounded"
          style={{ backgroundColor: zetColors.primary[200] }}
        ></Stack>
      )}
      {focused && (
        <LimeLight
          style={{
            position: 'absolute',
            width: '100%',
            height: '100%',
            bottom: 0,
            zIndex: -1,
          }}
        />
      )}
      <Icon
        type={icon}
        color={focused ? zetColors.primary[200] : zetColors.grays[80]}
      />
      <Text
        style={{ width: 60, textAlign: 'center' }}
        className={`leading-4 ${
          focused ? 'text-primary-200' : 'text-grays-60'
        }`}
      >
        {label}
      </Text>
    </Stack>
  )
}

export default BottomTabLayout
